import React, { Component } from 'react';
import { observer } from 'mobx-react';
import axios from 'axios';
import { Field, FormGroup, Radio, RadioGroup } from '@availity/form';
import '@availity/yup';
import { SelectField } from '@availity/select';
import { DateField } from '@availity/date';
import { Row, Col, Button, Label, UncontrolledAlert } from 'reactstrap';
import * as yup from 'yup';
import moment from 'moment';
import PropTypes from 'prop-types';
import ProgressValidatedForm from '../../Common/components/ProgressValidatedForm';
import housingstore from '../stores/housingstore';
import withNavigate from '../../Common/components/withNavigate';

@observer
class MemberInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInfo: false
    };

    if (
      housingstore.getSupportiveHousingRouteStatus('/') !== 'completed' &&
      housingstore.getSupportiveHousingRouteStatus('/') !== 'active'
    ) {
      housingstore.setSupportiveHousingPageStatus('#', 'active');
      housingstore.setSupportiveHousingRouteStatus('/', 'active');
    }

    if(window.performance) {
			if(performance.navigation.type == 1) {
        housingstore.resetSupportiveHousingPage();
				window.location.href = '#';
			}
		}
  }

  componentDidMount() {
    if (housingstore.getCountyListCount() === 0) {
      const URL = "/SupportiveHousingAssessment/EN/configupdate/assessment.config";
      axios({
        method: 'get',
        url: URL,
      })
        .then(function (response) {
          housingstore.setCountyList(response.data["assessment.config"][0].codeValues);
        })
        .catch(function (error) {
          return error;
        });
   }

    window.onpopstate = () => {
      this.props.navigate(1);
    }
  }

  setMemberInformation = event => {
    const { name, value } = event.target;
    housingstore.setMemberInfo(name, value);
  }

  setMemberCounty = value => {
    housingstore.setMemberCounty(value);
  }

  setInitReAuth = value => {
    housingstore.setInitReAuth(value);
  }

  setAssessDate = value => {
    housingstore.setAssessDate(value);
  }

  setMemberDateOfBirth = value => {
    housingstore.setMemberDateOfBirth(value);
  }

  setMemState = value => {
    housingstore.setMemberState(value)
  }

  setMemTribe = value => {
    housingstore.setMemberTribeDetails(value);
  }

  setMemVet = value => {
    housingstore.setMemberVeteranDetails(value);
  }

  setIsHomeless = value => {
    housingstore.setIsHomeless(value);
    if (value === 'No'){
      housingstore.setIsEnrolleeEligibleForAHAH('');
    }
  }

  setIsEnrolleeEligibleForAHAH = value => {
    housingstore.setIsEnrolleeEligibleForAHAH(value);
  }

  setMemPhone = event => {
    const { value } = event.target;
    housingstore.setMemberPhoneNumber(value);
  }

  setMemProvOne = event => {
    const { value } = event.target;
    const { attachments = [], memberInfo } = housingstore;
    if(value !== memberInfo.memProvOne && attachments?.length > 0){
      housingstore.resetAllAttachments();
      this.setState({showInfo: true});
    }
    housingstore.setMemProvOne(value);
  }

  setPhoneType = value => {
    housingstore.setMemberPhoneType(value);
  }

  setGenderType = value => {
    housingstore.setMemberGenderType(value);
  }

  setNameOfContact = event => {
    const { value } = event.target;
    housingstore.setNameOfContact(value);
  }

  submit = (pendingRoute) => {
    const { navigate } = this.props;
    housingstore.setSupportiveHousingPageStatus('#', 'active');
    housingstore.setSupportiveHousingRouteStatus("/", 'completed');
    navigate(pendingRoute || '/healthneeds');
  }

  render() {
    const { showInfo } = this.state;
    const { userAgent } = navigator;
    const { memberInfo, phoneTypesList, currentDate, genderTypes, supportiveHousingPagesAHAH, supportiveHousingPagesNoAHAH, countyList } = housingstore;
    const {
      initReauth,
      memLast,
      memFirst,
      memMiddle,
      memberPrefName,
      memGender,
      memDOB,
      dateAssessmentComp,
      isHomeless,
      isEnrolleeEligibleForAHAH,
      memAddr,
      memCity,
      memCounty,
      memState,
      memZip,
      memPhone,
      phoneType,
      nameOfContact,
      memEmail,
      memTribe,
      tribeDetails,
      memVet,
      vetDetails,
      memProvOne
    } = memberInfo;

    const supportiveHousingPages = (isHomeless === 'Yes' && isEnrolleeEligibleForAHAH === 'Yes' ? supportiveHousingPagesAHAH : supportiveHousingPagesNoAHAH);

    return (
      <>
        <div className="border-form">
          <div className='spacer-50' />

          <small className="required-fields">*required fields</small>
          <div className="spacer-48" />
          <h2 className="poppinsH2">
            Potential Enrollee Information
          </h2>
          {showInfo  &&
            <Row className="pl-32 mt-3">
              <Col>
                <UncontrolledAlert color='danger' fade>
                  <strong>
                    Change in ProviderOne ID required all the docs to upload again..!
                  </strong>
                </UncontrolledAlert>
              </Col>
            </Row>
          }
          <div className="spacer-64" />
          <ProgressValidatedForm
            pages={supportiveHousingPages}
            enableReinitialize={isHomeless !== '' || memTribe !== ''}
            initialValues={{
              assessmentRadio: initReauth,
              memberLast: memLast,
              memberMiddle: memMiddle,
              memberFirst: memFirst,
              memberPrefName: memberPrefName,
              memGender: memGender,
              memDOB: memDOB,
              formDate: currentDate,
              assessDate: dateAssessmentComp,
              ishomelessRadio: isHomeless,
              isEnrolleeEligibleForAHAHRadio: isEnrolleeEligibleForAHAH,
              memAddr: memAddr,
              memCity: memCity,
              memCounty: memCounty,
              memState: memState,
              memZip: memZip,
              memPhone: memPhone,
              memPhoneType: phoneType,
              nameOfContact: nameOfContact,
              memEmail: memEmail,
              memProvOne: memProvOne,
              wash_suffix: "WA",
              tribe_radio: memTribe,
              vet_radio: memVet,
              tribeField: tribeDetails,
              vetField: vetDetails,
            }}
            onSubmit={this.submit}
            validationSchema={yup.object().shape({
              assessmentRadio: yup.string().required('Please select an option before continuing!'),
              memberLast: yup.string()
                .matches(/^[A-Za-z0-9 \',\^\-&ÄäÖöÜü]+$/, 'Last name should be alpha-numeric')
                .required('Last Name is required'),
              memberMiddle: yup.string()
                .matches(/^[A-Za-z]+$/, 'Middle initial should be alphabets only'),
              memberFirst: yup.string()
                .matches(/^[A-Za-z0-9 \',\^\-&ÄäÖöÜü]+$/, 'First name should be alpha-numeric')
                .required('First name is required'),
              memberPrefName: yup.string()
                .matches(/^[A-Za-z0-9 \',\^\-&ÄäÖöÜü]+$/, 'First name should be alpha-numeric'),
              memDOB: yup.date()
                .max(moment().subtract(16, 'years').format('MM/DD/YYYY'), 'Supportive Housing enrollees must be at least 16 years old')
                .required("Date of birth is required")
                .typeError("Date of birth is required"),
              assessDate: yup.date()
                .min(moment().subtract(14, 'days').format('MM/DD/YYYY'), `Date Assessment Completed should be no more than 2 weeks before today’s date. 
                If the assessment is more than 2 weeks old, please contact your FCS Manager 
                or the FCS team (FCSTPA@Wellpoint.com/844.451.2828) for an exception.`)
                .max(moment().format('MM/DD/YYYY'), 'Date cannot be in the future')
                .required('Date Assessment Completed is required')
                .typeError('Date Assessment Completed is required'),
              memAddr: yup.string().isRequired((isHomeless === 'No'), "Address is required"),
              ishomelessRadio: yup.string().required('Please select an option before continuing!'),
              isEnrolleeEligibleForAHAHRadio: yup.string().when('ishomelessRadio', {
                is: 'Yes',
                then: yup.string().required('Please select an option before continuing!'),
              }),
              memCity: yup.string()
                .required('City is required'),
              memCounty: yup.string()
                .required('County is required')
                .matches(/^[A-Za-z][A-Za-z\s]+[A-Za-z]$/, 'Invalid Format'),
              memZip: yup.string()
                .isRequired((isHomeless === 'No' || memAddr !== ''), "Zip is required")
                .min(5, 'Zip should only be 5 digits')
                .matches(/^\d{5}$/, 'Zip should only be 5 digits'),
              memPhone: yup.string()
                .matches(/^\d{10}$/, 'Phone number must be 10 digits with no hyphens')
                .isRequired(phoneType !== '', 'Phone Number is required'),
              memPhoneType: yup.string().isRequired(memPhone.length === 10, 'Phone Number Type is required'),
              memGender: yup.string().required('Gender is required'),
              nameOfContact: yup.string()
                .matches(/^[A-Za-z0-9 \',\^\-&ÄäÖöÜü]+$/, 'Name should be alpha-numeric')
                .isRequired((
                  phoneType === 'Case Manager' ||
                  phoneType === 'Family Member' ||
                  phoneType === 'Friend' ||
                  phoneType === 'Guardian' ||
                  phoneType === 'Other'
                ), 'Name of Contact is required'),
              memEmail: yup.string(),
              memProvOne: yup.string()
                .min(9, 'Please enter 9 digits')
                .matches(/\d{9}/, 'Provider Id should be only 9 digits, no special characters or alphabets')
                .required('Provider One Id is required'),
              tribeField: yup.string().isRequired(memTribe === 'Yes', 'Member Tribe is required'),
            })}
          >
            <RadioGroup inline name="assessmentRadio" value={initReauth} onChange={this.setInitReAuth}>
              <Radio name="assessmentRadio" label="Initial Assessment" value="Initial Assessment" />
              <Radio name="assessmentRadio" label="Reauthorization" value="Reauthorization" />
            </RadioGroup>
            <div className="spacer" />
            <Row>
              <Col className="pl-17r-9" xs="12" sm="4">
                <FormGroup for="memberLast" className="label-font">
                  <Label htmlFor="memberLast">
                    Last Name*
                  </Label>
                  <Field
                    type="text"
                    id="memberLast"
                    name="memberLast"
                    className="straighten-borders"
                    value={memLast}
                    onChange={this.setMemberInformation}
                    maxLength={50}
                  />
                </FormGroup>
              </Col>
              <Col className='plr-9' xs='12' sm='2'>
                <FormGroup for='memberMiddle' className='label-font'>
                  <Label for='memberMiddle'>
                    Middle Initial
                  </Label>
                  <Field
                    type='text'
                    id='memberMiddle'
                    name='memberMiddle'
                    className='straighten-borders'
                    value={memMiddle}
                    onChange={this.setMemberInformation}
                    maxLength={2}
                  />
                </FormGroup>
              </Col>
              <Col className="plr-9" xs="12" sm="4">
                <FormGroup for="memberFirst" className="label-font">
                  <Label htmlFor="memberFirst">
                    First Name*
                  </Label>
                  <Field
                    type="text"
                    id="memberFirst"
                    name="memberFirst"
                    className="straighten-borders"
                    value={memFirst}
                    onChange={this.setMemberInformation}
                    maxLength={50}
                  />
                </FormGroup>
              </Col>
            </Row>

            <div className="spacer-48" />

            <Row>
              <Col xs='12' sm='4'>
                <FormGroup for='memPrefName' className='label-font'>
                  <Label htmlFor='memberPrefName'>
                    Preferred Name
                  </Label>
                  <Field
                    type='text'
                    id='memberPrefName'
                    name='memberPrefName'
                    className='straighten-borders'
                    value={memberPrefName}
                    onChange={this.setMemberInformation}
                    maxLength={50}
                  />
                </FormGroup>
              </Col>
              <Col className='plr-9' xs='12' sm='3'>
                <FormGroup for='memGender' className='label-font'>
                  <SelectField
                    name='memGender'
                    className='straighten-borders pTypeList'
                    label='Gender*'
                    value={memGender}
                    onChange={this.setGenderType}
                    options={genderTypes.map(genderType => (
                      {
                        value: genderType.value, label: genderType.name
                      }
                    ))}
                  />
                </FormGroup>
              </Col>
              <Col className='plr-9' xs="12" sm="3">
                <FormGroup for="memDOB" className="label-font">
                  <DateField
                    id="memDOB"
                    name="memDOB"
                    label="Date of Birth*"
                    value={memDOB}
                    className="straighten-borders"
                    onChange={this.setMemberDateOfBirth}
                    datePickerProps={{
                      showDefaultInputIcon: true,
                      inputIconPosition: 'after',
                      autoComplete: /edg/i.test(userAgent) ? 'autofill-off-edge' : 'off',
                      phrases: {
                        focusStartDate: 'Select date of birth'
                      }
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>

            <div className="spacer-48" />

            <Row>
              <Col className="pl-17r-9" xs="12" sm="2">
                <FormGroup for="formDate" className="label-font">
                  <Label htmlFor="formDate">
                    Date Received
                  </Label>
                  <Field
                    type="text"
                    id="formDate"
                    name="formDate"
                    className="straighten-borders"
                    value={currentDate}
                    readOnly
                  />
                </FormGroup>
              </Col>
              <Col className="plr-9" xs="12" sm="3">
                <FormGroup for="assessDate" className="label-font">
                  <DateField
                    id="assessDate"
                    name="assessDate"
                    label="Date Assessment Completed*"
                    className="straighten-borders"
                    value={dateAssessmentComp}
                    onChange={this.setAssessDate}
                    datePickerProps={{
                      showDefaultInputIcon: true,
                      inputIconPosition: 'after',
                      autoComplete: /edg/i.test(userAgent) ? 'autofill-off-edge' : 'off',
                      phrases: {
                        focusStartDate: 'Select Date Assessment Completed'
                      }
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>

            <div className="spacer-48" />

            <Row>
              <div className='label-font plr-9'>
                Is the potential enrollee experiencing homelessness?*
              </div>
            </Row>
            <div className='mt-3' />
            <div>
              <RadioGroup inline value={isHomeless} name="ishomelessRadio" onChange={this.setIsHomeless}>
                <Radio className="label-font-round" label="Yes" value="Yes" />
                <Radio className="label-font-round" label="No" value="No" />
              </RadioGroup>
            </div>
            
            <div className='label-font address-spacer'>
              Per <a style={{ textDecoration: 'underline' }} href="https://app.leg.wa.gov/rcw/default.aspx?cite=43.185C.010">RCW 43.185C.010</a> homeless person means an individual living outside or in a building
              not meant for human habitation or which they have no legal right to occupy, or in an emergency
              shelter or in a temporary housing program which may include transitional and supportive housing program
              if habitation time limits exists.
            </div>
            <div className='label-font address-spacer'>
              If the potential enrollee is experiencing homelessness, they may be eligible for the Apple Health and Homes Rental Assistance Program (AHAH-RAP). 
              Review the AHAH-RAP eligibility requirements in the <a style={{ textDecoration: 'underline' }} href="https://www.provider.wellpoint.com/docs/gpp/WAWA_WLP_CAID_RentalAssistProgramQRG.pdf?v=202406202121">AHAH-RAP Quick Reference Guide</a>.
            </div>
            { isHomeless === 'Yes' && (
              <>
            <Row>
              <div className='label-font plr-9'>
                Would the potential enrollee like to be considered for the AHAH Rental Assistance Program (AHAH-RAP)?*
              </div>
            </Row>
            <div className='mt-3' />
            <Row>
              <Col>
                <RadioGroup inline value={isEnrolleeEligibleForAHAH} name="isEnrolleeEligibleForAHAHRadio" onChange={this.setIsEnrolleeEligibleForAHAH}>
                  <Radio className="label-font-round" label="Yes" value="Yes" />
                  <Radio className="label-font-round" label="No" value="No" />
                </RadioGroup>
              </Col>
            </Row>
            </>
            )}
              
            <Row>
              {/* <Col className="pl-17r-9" xs="12" sm="2">
                <Label className="label-font" htmlFor="ishomeless-radio">
                  Is experiencing homelessness?
                </Label>
                <RadioGroup inline value={isHomeless} name="ishomelessRadio" onChange={this.setIsHomeless}>
                  <Radio className="label-font-round" label="Yes" value="Yes"  />
                  <Radio className="label-font-round" label="No" value="No" />
                </RadioGroup>
              </Col> */}
              {
                isHomeless === 'No' ?
                  <>
                    <Col className="plr-9" xs="12" sm="4">
                      <Label className="label-font" htmlFor="memAddr">
                        Address (not required if homeless)*
                      </Label>
                      <FormGroup for="memAddr" className="label-font">
                        <Field
                          type="text"
                          name="memAddr"
                          id="memAddr"
                          className="straighten-borders"
                          value={memAddr}
                          onChange={this.setMemberInformation}
                        />
                      </FormGroup>
                    </Col>
                  </>
                  :
                  <>
                    <Col className="plr-9" xs="12" sm="4">
                      <Label className="label-font" htmlFor="memAddr">
                        Address (not required if homeless)
                      </Label>
                      <FormGroup for="memAddr" className="label-font">
                        <Field
                          type="text"
                          name="memAddr"
                          id="memAddr"
                          className="straighten-borders"
                          value={memAddr}
                          onChange={this.setMemberInformation}
                        />
                      </FormGroup>
                    </Col>
                  </>
              }
              <Col className="plr-9" xs="12" sm="2">
                <Label className="label-font" htmlFor="memCity">
                  City*
                </Label>
                <FormGroup for="memCity" className="label-font">
                  <Field
                    type="text"
                    name="memCity"
                    id="memCity"
                    className="straighten-borders"
                    value={memCity}
                    onChange={this.setMemberInformation}
                  />
                </FormGroup>
              </Col>
              <Col className='plr-9' xs='12' sm='2'>
                <FormGroup for='memCounty' className='label-font'>
                  {/* <Field
                    type='text'
                    name='memCounty'
                    id='memCounty'
                    className='straighten-borders'
                    label='County*'
                    value={memCounty}
                    onChange={this.setMemberInformation}
                    maxLength={50}
                  /> */}
                  <SelectField
                    name="memCounty"
                    label="County*"
                    className="straighten-borders pTypeList"
                    value={memCounty}
                    onChange={this.setMemberCounty}
                    options={countyList.map(county => (
                      {
                        value: county.code, label: county.value
                      }
                    ))}
                  />
                </FormGroup>
              </Col>
            </Row>

            <div className='spacer-38' />

            <Row>
              <Col className="plr-9" xs="12" sm="2">
                <FormGroup for="memState" className="label-font">
                  <Field
                    type="text"
                    id="memState"
                    name="memState"
                    className="straighten-borders"
                    label='State'
                    value={memState}
                    readOnly
                  />
                </FormGroup>
              </Col>
              {
                (isHomeless === 'No' || memAddr !== '') ?
                  <>
                    <Col className="pl-9r-15" xs="12" sm="2">
                      <Label className="label-font" htmlFor="memZip">
                        Zip*
                      </Label>
                      <FormGroup for="memZip" className="label-font">
                        <Field
                          type="text"
                          name="memZip"
                          id="memZip"
                          className="straighten-borders"
                          value={memZip}
                          onChange={this.setMemberInformation}
                          minLength={5}
                          maxLength={5}
                        />
                      </FormGroup>
                    </Col>
                  </>
                  :
                  <>
                    <Col className="pl-9r-15" xs="12" sm="2">
                      <Label className="label-font" htmlFor="memZip">
                        Zip
                      </Label>
                      <FormGroup for="memZip" className="label-font">
                        <Field
                          type="text"
                          name="memZip"
                          id="memZip"
                          className="straighten-borders"
                          value={memZip}
                          onChange={this.setMemberInformation}
                          minLength={5}
                          maxLength={5}
                        />
                      </FormGroup>
                    </Col>
                  </>
              }

            </Row>
            <div className="spacer-48" />

            <div className="spacer-48" />
            <Row>
              <Col className="pl-17r-9" xs="12" sm="3">
                <FormGroup for="memPhone" className="label-font">
                  <Field
                    type="text"
                    name="memPhone"
                    id="memPhone"
                    className="straighten-borders"
                    label={`${phoneType !== '' ? 'Phone Number*' : 'Phone Number'}`}
                    value={memPhone}
                    onChange={this.setMemPhone}
                    maxLength={10}
                  />
                </FormGroup>
              </Col>
              <Col className="plr-9" xs="12" sm="3">
                <Label className="label-font" htmlFor="memPhoneType">
                  {`${memPhone.length === 10 ? 'Phone Number Type*' : 'Phone Number Type'}`}
                </Label>
                <FormGroup for="memPhoneType" className="label-font">
                  <SelectField
                    type="select"
                    name="memPhoneType"
                    className="straighten-borders pTypeList"
                    placeholder="Select"
                    value={phoneType}
                    onChange={this.setPhoneType}
                    options={phoneTypesList.map(type => (
                      {
                        value: type.value,
                        label: type.id
                      }
                    ))}
                  />
                </FormGroup>
              </Col>
              <Col className="plr-9" xs="12" sm="3">
                <FormGroup for="nameOfContact">
                  {
                    (
                      phoneType === 'Case Manager' ||
                      phoneType === 'Family Member' ||
                      phoneType === 'Friend' ||
                      phoneType === 'Guardian' ||
                      phoneType === 'Other'
                    ) ?
                      <Field
                        type="text"
                        name="nameOfContact"
                        id="nameOfContact"
                        className="straighten-borders"
                        label="Name*"
                        value={nameOfContact}
                        onChange={this.setNameOfContact}
                        maxLength={50}
                      />
                      :
                      <Field
                        type="text"
                        name="nameOfContact"
                        id="nameOfContact"
                        className="straighten-borders"
                        label="Name"
                        value={nameOfContact}
                        readOnly
                      />
                  }
                </FormGroup>
              </Col>
            </Row>

            <div className="spacer-28" />

            <Row>
              <Col className="pl-17r-9" xs="12" sm="3">
                <FormGroup for="memEmail" className="label-font">
                  <Field
                    type="text"
                    name="memEmail"
                    id="memEmail"
                    className="straighten-borders"
                    label="Email"
                    value={memEmail}
                    placeholder='name@domainname.com'
                    onChange={this.setMemberInformation}
                  />
                </FormGroup>
              </Col>
              <Col className="pl-9 pr-0" xs="12" sm="2">
                <Field
                  type="text"
                  name="memProvOne"
                  id="memProvOne"
                  className="straighten-borders"
                  label="ProviderOne ID*"
                  value={memProvOne}
                  onChange={this.setMemProvOne}
                  maxLength={9}
                />
              </Col>
              <Col className="pl-0" xs="12" sm="2">
                <FormGroup for="wash_suffix" className="label-font">
                  <Field
                    type="text"
                    id="wash_suffix"
                    name="wash_suffix"
                    className='straighten-borders memStateCode-suffix'
                    value="WA"
                    disabled
                    aria-label='WA Suffix'
                  />
                </FormGroup>
              </Col>
            </Row>
            <div className="spacer-28" />
            <Row>
              <Col className="pl-17r-9" xs="6" sm="4">
                <Label className="label-font" htmlFor="tribe-radio">
                  Member of a federally recognized American Indian/Alaska tribe?
                </Label>
                <RadioGroup inline value={memTribe} name="tribe_radio" onChange={this.setMemTribe}>
                  <Radio className="label-font-round" label="Yes" value="Yes" />
                  <Radio className="label-font-round" label="No" value="No" />
                </RadioGroup>
              </Col>
              <Col className="plr-9" xs="6" sm="4">
                <Label className="label-font" htmlFor="vet-radio">
                  Veteran
                </Label>
                <RadioGroup inline value={memVet} name="vet_radio" onChange={this.setMemVet}>
                  <Radio className="label-font-round" label="Yes" value="Yes" />
                  <Radio className="label-font-round" label="No" value="No" />
                </RadioGroup>
              </Col>
            </Row>
            <Row>
              {
                memTribe !== 'Yes' ?
                  <div className="disableGrievance">
                    <Col className="pr-9">
                      <FormGroup for="tribeField">
                        <Field
                          type="text"
                          name="tribeField"
                          id="tribeField"
                          className="straighten-borders"
                          label="If yes, please specify which tribe:"
                          value={tribeDetails}
                          onChange={this.setMemberInformation}
                          disabled
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                  </div>
                  :
                  <div className="tribeFieldDiv">
                    <Col className="pr-9">
                      <FormGroup for="tribeField" className="label-font">
                        <Field
                          type="text"
                          name="tribeField"
                          id="tribeField"
                          className="straighten-borders"
                          label="If yes, please specify which tribe:"
                          value={tribeDetails}
                          onChange={this.setMemberInformation}
                        />
                      </FormGroup>
                    </Col>
                  </div>
              }
              {
                memVet !== 'Yes' ?
                  <div className="disableGrievance">
                    <Col className="plr-9">
                      <FormGroup for="vetField" className="label-font">
                        <Field
                          type="text"
                          name="vetField"
                          id="vetField"
                          className="straighten-borders"
                          label="If yes, which military branch:"
                          value={vetDetails}
                          onChange={this.setMemberInformation}
                          disabled
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                  </div>
                  :
                  <div className="vetFieldDiv label-font">
                    <Col className="plr-9">
                      <FormGroup for="vetField" className="label-font">
                        <Field
                          type="text"
                          name="vetField"
                          id="vetField"
                          className="straighten-borders"
                          label="If yes, which military branch:"
                          value={vetDetails}
                          onChange={this.setMemberInformation}
                        />
                      </FormGroup>
                    </Col>
                  </div>
              }
            </Row>
            <div className="spacer-48" />
            <Button type="submit" color={"primary"} className={'btn btn-primary nextBtn'}>
              Next
            </Button>
          </ProgressValidatedForm>
        </div>
        <div className="pb-spacerRem-4" />
      </>
    );
  }
}

export default withNavigate(MemberInformation);

MemberInformation.propTypes = {
  navigate: PropTypes.func
};











































































